//Dependencies
import React, { useCallback } from 'react';
import { Icon } from "leaflet";
import { Map, TileLayer,  Marker, Tooltip } from "react-leaflet";
import { useDispatch } from 'react-redux';

const markerGreen = new Icon(
  {
    iconUrl: 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/icons%2Fv02%2Fmarker06.png?alt=media&token=f9963620-98af-4820-b940-bc931a49b881',
    shadowUrl: 'https://firebasestorage.googleapis.com/v0/b/builten360.appspot.com/o/icons%2Fv02%2Fshadow.png?alt=media&token=e2660495-7f01-481d-bbe3-a0c107708e9f',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [1, -34],
    shadowSize: [40, 40]
  });

const MapPage02 = (props) =>
{
  const dispatch = useDispatch();

  const { name, center, zoom } = props;  
  
  const layer1 = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  const dragMap = useCallback((e) => 
  {
    dispatch({type: 'SET_CENTER', center : e.target.getCenter()});
  }, [dispatch]); 

  const mapZoom = (e) =>
  {
    dispatch({type: 'SET_ZOOM', zoom : e.target.getZoom()});
  }
  
  return(
    <div
      style = {{ height : '100%', width : '100%' }}
    >
      <Map
        center = {center} 
        zoom = {zoom} 
        style = {{height : '100%', width : '100%'}}
        onzoomend = {(e) => mapZoom(e)} 
        ondragend = {(e) => dragMap(e)}
      >
        <TileLayer
          url = {layer1}
          minZoom = {5}
          maxZoom = {19}
        />
        
        <Marker
          position = {center}
          icon = {markerGreen}
        >
          <Tooltip direction = "right" offset = {[20, -20]} permanent = {true}>{`${name.toUpperCase()}`}</Tooltip>
        </Marker>
      </Map>
    </div>
  );
}

export default MapPage02;